export default __webpack_public_path__ + "static/icon-5-5-ce6cdf136f9490c7548da2ecd056a973.png";